module.exports = __webpack_public_path__ + "img/home_24.7b814bcb.png";